import React from 'react';
import { Link } from 'react-router-dom';
import { PrivacyPolicy, TermsOfService } from './content';
import './legal.css';

// Public, readable without signing in: /privacy and /terms.
export default function LegalPage({ doc }) {
  const isPrivacy = doc === 'privacy';
  return (
    <div className="legal-page">
      <div className="legal-doc">
        <Link to="/" className="legal-back">← ShopBook</Link>
        <h1>{isPrivacy ? 'Privacy Policy' : 'Terms of Service'}</h1>
        {isPrivacy ? <PrivacyPolicy /> : <TermsOfService />}
        <p className="legal-switch">
          {isPrivacy
            ? <>See also the <Link to="/terms">Terms of Service</Link>.</>
            : <>See also the <Link to="/privacy">Privacy Policy</Link>.</>}
        </p>
      </div>
    </div>
  );
}
